import { ApiStatuses, IDateRange, IPagination, SortTypes } from "../../app/types";
import { IProductSummary} from "../productsPortfolio/types";

export enum EOrderStatus {
  Payment = "payment",
  Pending = "pending",
  Queued = "queued",
  Fetched = "fetched",
  Collecting = "collecting",
  Collected = "collected",
  Ready = "ready",
  Delivering = "delivering",
  Delivered = "delivered",
  Error = "error",
  Cancelled = "cancelled"
}

export interface IOrderEvent {
  id: string;
  eventType: string;
  eventData: Record<string, string>;
  eventTime: string;
  isError: boolean;
}

export interface IOrderUser {
  name: string;
  address: string;
  phoneNumber: string;
  locale: string;
}

export interface IOrder {
  id: string;
  status: EOrderStatus;
  siteId: number;
  systemId: number;
  products: IOrderProduct[];
  deliveryDate: string;
  deliveryTime: string;
  priority: number;
  displayCode: number;
  pinCode: number;
  user: IOrderUser;
  events: IOrderEvent[];
  createdAt: string;
  updatedAt: string;
}

export interface IOrderProduct {
  productId: number;
  product: IProductSummary;
  quantity: number;
  collectedQuantity: number;
  returnedQuantity: number;
  refundQuantity: number;
}

export interface IOrdersListFilters extends IPagination {
  statusFilter: EOrderStatus[];
  dateFilter: IDateRange;
  dateFilterSort: SortTypes;
}

export interface IOrdersSliceState {
  list: IOrder[];
  filters: IOrdersListFilters;
  selectedOrdersToProcess: IOrder[];
  selectedOrder?: IOrder;
  status: ApiStatuses;
  detailsStatus: ApiStatuses;
  selectedOrderId?: number;
  orderNotFound: boolean;
}

export interface IFetchListProps {
  siteId: number;
  filters: IOrdersListFilters
}
